import React from "react";
import ReactMarkdown from "react-markdown";
import Box from "@mui/material/Box";

export const AndroidAppPrivacyPolicy = () => {
  const markdown = `
# Privacy Policy for VetNebula WebView App
Last Updated: May 1, 2025

This Privacy Policy explains how the VetNebula App handles user data when accessing https://app.vetnebula.com.

By using this App, you agree to the terms outlined in this policy.

## 1. Information We Do Not Collect
This App does not collect, store, or transmit:

- Personal user data (name, email, phone number, etc.)
- Location data
- Device identifiers (IMEI, MAC address, etc.)
- Payment or financial information

## 2. Data Handled by the WebView
The App functions as a WebView wrapper for https://app.vetnebula.com. Any data entered into the website (such as login credentials, forms, or cookies) is managed by VetNebula's own privacy policy, not this App.

**Types of Data the WebView May Process:**
- Cookies & Session Data (for login persistence)
- Form Data (if submitted on the website)
- Local Storage (used by the website for caching)

We do not access, store, or share this data.

## 3. Permissions Used by the App
The App requests the following Android permissions:

- Internet Access (to load the website)
- Network State Access (to check connectivity)

No other permissions are required.

## 4. Third-Party Services
The App itself does not integrate third-party analytics, ads, or tracking. However, the website (https://app.vetnebula.com) may use its own third-party services. Refer to VetNebula's Privacy Policy for details.

## 5. Security
- The App uses HTTPS encryption for secure communication.
- No personal data is stored locally on the device.
- WebView cache and cookies are managed by Android's default mechanisms.

## 6. Changes to This Policy
We may update this Privacy Policy. Check this page for the latest version.

## 7. Contact Us
For questions about this policy, contact:

📧 contact@vetnebula.com

🌐 vetnebula.com

  `;

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </Box>
  );
};
